const enCharge = {
  charge: {
    title: {
      chargeList: 'Charge List',
    },

    label: {
      code: 'Code',
      payer: 'Payer',
      status: 'Status',
      amount: 'Amount',
      type: 'Type',
      pay: 'Pay',
      payUsingBalance: 'Pay using balance',
      confirmPayment: 'Confirm payment',
      appointment: 'Appointment',
      generateReport: 'Generate report',
      payments: 'Payments',
      show: 'Show',
      total: 'Total',
      totalAmountToPay: 'Total amount to pay',
      paySelected: 'Pay selected',
      chargeReport: 'Charge report',
    },

    status: {
      PENDING: 'Pending',
      RECEIVED: 'Received',
      CONFIRMED: 'Confirmed',
      OVERDUE: 'Overdue',
      OTHER: 'Other',
    },

    types: {
      EVICTION: 'Eviction Confirmation',
      RENT_OUT: 'Facilitated Termination',
      FCI: 'FCI',
      SAAS_SUBSCRIPTION: 'SaaS Subscription',
    },

    hint: {
      fciMeaning: 'Property Conservation Fund',
      fci: 'Payment related to the FCI that Hauseful advanced to the vendor who carried out the renovation.',
      wantToPay: 'Do you want to pay this charge?',
    },

    messages: {
      successfullyPaid: 'Charge successfully paid',
      chargeNotFound: 'No charges found.',
    },
  },
};

export default enCharge;
